import { AsyncDropdown } from 'src/app/models/async-dropdown';

export class BudgetUpdateModel {
  identifier: string;
  type: AsyncDropdown;
  department: AsyncDropdown;
  jobCode: AsyncDropdown;

  public constructor(init?: Partial<BudgetUpdateModel>) {
    Object.assign(this, init);
  }
}
